import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect } from 'react';
import { Container, Card, Table } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import Category from './Category';
import { useTranslation } from "react-i18next";

const PlanDetails = () => {
    const {t,i18n} = useTranslation()
    const location = useLocation()

    useEffect(() => {
        document.querySelector("title").textContent = "プラン詳細 - ourt AI"
    },[location.pathname])

    return(
        <div className="wrapper">
            <header className="App-header"></header>
            <Header />
            <Category />
            <Container>
                {/* ヘッダーセクション */}
                <div className="text-center mb-5 py-5" style={{
                    background: "#f8f9ff",
                    borderRadius: "15px",
                    color: "#2d3748",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    border: "1px solid #e2e8f0"
                }}>
                    <h1 className="mb-3" style={{fontSize:"32px", fontWeight:"600", color:"#2d3748"}}>
                        プラン詳細
                    </h1>
                    <p className="lead" style={{fontSize:"18px", color:"#64748b", fontWeight:"400"}}>
                        各プランの具体的な生成枚数と機能について
                    </p>
                </div>

                {/* 詳細情報セクション */}
                <div className="mb-5">
                    <h2 className="text-center mb-4" style={{fontSize:"26px", fontWeight:"600", color:"#2d3748"}}>
                        料金プラン詳細比較
                    </h2>
                    <p className="text-center mb-4" style={{color:"#64748b", fontSize:"16px"}}>
                        ※口座振り込みは個別にお問い合わせください。
                    </p>
                    
                    {/* プラン比較テーブル */}
                    <div className="table-responsive" style={{
                        borderRadius:"12px",
                        overflow:"hidden",
                        boxShadow:"0 4px 20px rgba(0,0,0,0.08)"
                    }}>
                        <Table bordered hover className="text-center mb-0" style={{border:"none"}}>
                            <thead style={{
                                background:"linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                                color:"white"
                            }}>
                                <tr>
                                    <th style={{width:"25%", padding:"16px", fontWeight:"600", border:"none"}}>機能</th>
                                    <th style={{width:"15%", padding:"16px", fontWeight:"600", border:"none"}}>Free</th>
                                    <th style={{width:"15%", padding:"16px", fontWeight:"600", border:"none"}}>Basic</th>
                                    <th style={{width:"15%", padding:"16px", fontWeight:"600", border:"none"}}>Standard</th>
                                    <th style={{width:"15%", padding:"16px", fontWeight:"600", border:"none"}}>Premium</th>
                                    <th style={{width:"15%", padding:"16px", fontWeight:"600", border:"none"}}>Premium+</th>
                                </tr>
                            </thead>
                            <tbody style={{background:"#ffffff"}}>
                                <tr style={{borderBottom:"1px solid #e2e8f0"}}>
                                    <td className="fw-bold text-start" style={{padding:"16px", background:"#f8fafc"}}>月額料金</td>
                                    <td className="text-success fw-bold" style={{padding:"16px", color:"#10b981"}}>$0</td>
                                    <td className="fw-bold" style={{padding:"16px", color:"#64748b"}}>$4 / 500円</td>
                                    <td className="fw-bold" style={{padding:"16px", color:"#6366f1"}}>$10 / 1,400円</td>
                                    <td className="fw-bold" style={{padding:"16px", color:"#8b5cf6"}}>$30 / 4,000円</td>
                                    <td className="fw-bold" style={{padding:"16px", color:"#a855f7"}}>$140 / 20,000円</td>
                                </tr>
                                <tr style={{borderBottom:"1px solid #e2e8f0"}}>
                                    <td className="fw-bold text-start" style={{padding:"16px", background:"#f8fafc"}}>広告表示</td>
                                    <td style={{padding:"16px"}}>あり</td>
                                    <td style={{padding:"16px"}}><Icon.CheckCircleFill className="text-success" /></td>
                                    <td style={{padding:"16px"}}><Icon.CheckCircleFill className="text-success" /></td>
                                    <td style={{padding:"16px"}}><Icon.CheckCircleFill className="text-success" /></td>
                                    <td style={{padding:"16px"}}><Icon.CheckCircleFill className="text-success" /></td>
                                </tr>
                                <tr style={{borderBottom:"1px solid #e2e8f0"}}>
                                    <td className="fw-bold text-start" style={{padding:"16px", background:"#f8fafc"}}>認証マーク</td>
                                    <td style={{padding:"16px"}}>青色</td>
                                    <td style={{padding:"16px"}}>青色</td>
                                    <td style={{padding:"16px"}}>黄色</td>
                                    <td style={{padding:"16px"}}>黄色</td>
                                    <td style={{padding:"16px"}}>黄色</td>
                                </tr>
                                <tr style={{borderBottom:"1px solid #e2e8f0"}}>
                                    <td className="fw-bold text-start" style={{padding:"16px", background:"#f8fafc"}}>画像生成方式</td>
                                    <td style={{padding:"16px"}}>ポイント消費</td>
                                    <td style={{padding:"16px"}}>ポイント消費<br/>(slowモード)</td>
                                    <td style={{padding:"16px"}}>回数制限あり ※1<br/>(最大100枚/日)</td>
                                    <td style={{padding:"16px"}}>回数制限あり ※2<br/>(最大400枚/日)</td>
                                    <td style={{padding:"16px"}}>制限なし ※3</td>
                                </tr>
                                <tr style={{borderBottom:"1px solid #e2e8f0"}}>
                                    <td className="fw-bold text-start" style={{padding:"16px", background:"#f8fafc"}}>生成画像ロゴ</td>
                                    <td style={{padding:"16px"}}>あり</td>
                                    <td style={{padding:"16px"}}><Icon.CheckCircleFill className="text-success" /></td>
                                    <td style={{padding:"16px"}}><Icon.CheckCircleFill className="text-success" /></td>
                                    <td style={{padding:"16px"}}><Icon.CheckCircleFill className="text-success" /></td>
                                    <td style={{padding:"16px"}}><Icon.CheckCircleFill className="text-success" /></td>
                                </tr>
                                <tr style={{borderBottom:"1px solid #e2e8f0"}}>
                                    <td className="fw-bold text-start" style={{padding:"16px", background:"#f8fafc"}}>DALL-E3生成回数</td>
                                    <td style={{padding:"16px"}}>ポイント消費</td>
                                    <td style={{padding:"16px"}}>ポイント消費</td>
                                    <td style={{padding:"16px"}}>ポイント消費</td>
                                    <td style={{padding:"16px"}}>50枚/月</td>
                                    <td style={{padding:"16px"}}>500枚/月</td>
                                </tr>
                                <tr style={{borderBottom:"1px solid #e2e8f0"}}>
                                    <td className="fw-bold text-start" style={{padding:"16px", background:"#f8fafc"}}>SD3生成回数</td>
                                    <td style={{padding:"16px"}}>ポイント消費</td>
                                    <td style={{padding:"16px"}}>ポイント消費</td>
                                    <td style={{padding:"16px"}}>ポイント消費</td>
                                    <td style={{padding:"16px"}}>50枚/月</td>
                                    <td style={{padding:"16px"}}>500枚/月</td>
                                </tr>
                                <tr style={{borderBottom:"1px solid #e2e8f0"}}>
                                    <td className="fw-bold text-start" style={{padding:"16px", background:"#f8fafc"}}>FLUX.1 schnell生成回数</td>
                                    <td style={{padding:"16px"}}>ポイント消費</td>
                                    <td style={{padding:"16px"}}>ポイント消費</td>
                                    <td style={{padding:"16px"}}>ポイント消費</td>
                                    <td style={{padding:"16px"}}>500枚/月</td>
                                    <td style={{padding:"16px"}}>5,000枚/月</td>
                                </tr>
                                <tr style={{borderBottom:"1px solid #e2e8f0"}}>
                                    <td className="fw-bold text-start" style={{padding:"16px", background:"#f8fafc"}}>生成履歴保存期間</td>
                                    <td style={{padding:"16px"}}>3日</td>
                                    <td style={{padding:"16px"}}>3日</td>
                                    <td style={{padding:"16px"}}>7日</td>
                                    <td style={{padding:"16px"}}>30日</td>
                                    <td style={{padding:"16px"}}>30日</td>
                                </tr>
                                <tr style={{borderBottom:"1px solid #e2e8f0"}}>
                                    <td className="fw-bold text-start" style={{padding:"16px", background:"#f8fafc"}}>画像zipダウンロード</td>
                                    <td style={{padding:"16px"}}>最大10枚</td>
                                    <td style={{padding:"16px"}}>最大30枚</td>
                                    <td style={{padding:"16px"}}>最大100枚</td>
                                    <td style={{padding:"16px"}}>最大300枚</td>
                                    <td style={{padding:"16px"}}>最大300枚</td>
                                </tr>
                                <tr style={{borderBottom:"1px solid #e2e8f0"}}>
                                    <td className="fw-bold text-start" style={{padding:"16px", background:"#f8fafc"}}>作品投稿上限</td>
                                    <td style={{padding:"16px"}}>150枚/月</td>
                                    <td style={{padding:"16px"}}>150枚/月</td>
                                    <td style={{padding:"16px"}}>350枚/月</td>
                                    <td style={{padding:"16px"}}>1,000枚/月</td>
                                    <td style={{padding:"16px"}}>1,000枚/月</td>
                                </tr>
                                <tr>
                                    <td className="fw-bold text-start" style={{padding:"16px", background:"#f8fafc"}}>優先生成</td>
                                    <td style={{padding:"16px"}}>-</td>
                                    <td style={{padding:"16px"}}>-</td>
                                    <td style={{padding:"16px"}}><Icon.CheckCircleFill className="text-success" /></td>
                                    <td style={{padding:"16px"}}><Icon.CheckCircleFill className="text-success" /></td>
                                    <td style={{padding:"16px"}}><Icon.CheckCircleFill className="text-success" /></td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>

                    {/* 注意事項 */}
                    <Card className="mt-4">
                        <Card.Header className="bg-light">
                            <h5 className="mb-0">注意事項</h5>
                        </Card.Header>
                        <Card.Body>
                            <div className="small">
                                <p><strong>※1</strong> 画像生成の利用回数については、以下の設定のいずれかに当てはまる場合は対象外であり、このプランに入っていてもポイントを消費しますのでご注意ください。またDALL-E3、Stable Diffusion 3(Turbo含む)、Stable Image Ultra、FLUX.1 schnellは対象外です。</p>
                                <ul>
                                    <li>stepsが30より大きい</li>
                                    <li>SD1.5モデルの解像度が1536x1536、1920x1080、1080x1920</li>
                                    <li>SDXLモデルの以下の解像度：2048x2048、1792x2304、1280x2560、2304x1792、2560x1280</li>
                                </ul>
                                
                                <p><strong>※2</strong> 直近24時間あたりの生成枚数です。また、以下は対象外になります。</p>
                                <ul>
                                    <li>モデルがDALL-E3、Stable Diffusion 3(Turbo含む)、Stable Image Ultra、FLUX.1 schnell</li>
                                    <li>stepsが30より大きい</li>
                                </ul>
                                
                                <p><strong>※3</strong> 画像生成の利用回数無制限については、以下の設定のいずれかに当てはまる場合は対象外であり、このプランに入っていてもポイントを消費しますのでご注意ください。またDALL-E3、Stable Diffusion 3(Turbo含む)、Stable Image Ultra、FLUX.1 schnellは対象外です。</p>
                                <ul>
                                    <li>stepsが50より大きい</li>
                                </ul>
                                
                                <p className="mt-3">・生成枚数はベストエフォートであり全ての枚数を使いきれることを保証するものではありません。<br />
                                混雑状況等により上限より少なくなることがあります。また生成数が著しく多い場合は枚数を制限する場合があります。予めご了承ください。</p>
                            </div>
                        </Card.Body>
                    </Card>
                </div>

                {/* 特定商取引法 */}
                <div>
                    <h3 className="mb-4">特定商取引法に基づく表記</h3>
                    <Table striped bordered hover className="mb-5">
                        <tbody>
                            <tr><th style={{width:"25%"}}>運営会社</th><td>アワート合同会社</td></tr>
                            <tr><th>代表者</th><td>元水 稜真</td></tr>
                            <tr><th>所在地</th><td>〒101-0024 東京都千代田区神田和泉町1番地6-16ヤマトビル405</td></tr>
                            <tr><th>電話番号</th><td>090-8835-2738 ※サービスについてのお問い合わせはその他の連絡先から行ってください。</td></tr>
                            <tr><th>その他の連絡先</th><td>
                                <div className="d-flex flex-column">
                                    <a href="https://twitter.com/ourt_ai" className="mb-1" target="_blank" rel="noopener noreferrer">X(旧Twitter)</a>
                                    <a href="https://discord.gg/646h4vFMv2" className="mb-1" target="_blank" rel="noopener noreferrer">Discord</a>
                                    <a href="https://lin.ee/9JVODFH" className="mb-1" target="_blank" rel="noopener noreferrer">LINE</a>
                                    <span>メール：contact＠ourt-ai.work</span>
                                </div>
                            </td></tr>
                            <tr><th>料金</th><td>消費税込みの価格で個別に記載。</td></tr>
                            <tr><th>代金の支払い方法</th><td>利用する決済サービスに記載の方法で行う。</td></tr>
                            <tr><th>代金の支払時期</th><td>月額課金制とし、決済を行った日に当月分が請求され、以降は解約しない限り自動的に毎月決済されます。</td></tr>
                            <tr><th>提供時期</th><td>決済後、アワートAI内へプランの反映を行った後に利用可能(3日以内)。</td></tr>
                            <tr><th>返品等についての特約に関する事項</th><td>契約成立後の返品、返金、キャンセルはできません。</td></tr>
                        </tbody>
                    </Table>
                </div>
            </Container>
            <Footer />
        </div>
    )
}

export default PlanDetails;
